

export class ExpenseTypeOutputWithoutStatus implements IExpenseTypeOutputWithoutStatus {
    /** The auto-generated id of the expense type  master */
    expense_type_id!: number;
    /** The expense type name with 255 character limit */
    expense_type_name!: string;

    constructor(data?: IExpenseTypeOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expense_type_id = _data["expense_type_id"];
            this.expense_type_name = _data["expense_type_name"];
        }
    }

    static fromJS(data: any): ExpenseTypeOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expense_type_id"] = this.expense_type_id;
        data["expense_type_name"] = this.expense_type_name;
        return data; 
    }
}

export interface IExpenseTypeOutputWithoutStatus {
    /** The auto-generated id of the expense type  master */
    expense_type_id: number;
    /** The expense type name with 255 character limit */
    expense_type_name: string;
}

